
const menuData = {
  Home: "Introduction",
  Retirement: {
    "Strategy: Overall": "RetireAt59AndHalf",
    "Strategy: SS Claim": "SSClaimCalculator",
    "Strategy: IRA/401K": "IRAStrategy",
    "Calculator: SS Amount": "SSAmountCalculator",
    "Calculator: SS Claim": "SSClaimCalculator",
  },
  
  Investments: {
    Equity: "UnderConstruction",
    "Fixed Income": "UnderConstruction",
  },

  Tax: {
    "Tax Bracket": "TaxCalculator",
    "Tax Loss Harvesting": "UnderConstruction",
    "Tax Efficient Investing": "UnderConstruction",
    "Income Tax": "UnderConstruction",
    "Capital Gains Tax": "UnderConstruction",
    "Estate Tax": "UnderConstruction",
  },

  Insurance: {
      "Life Insurance": "UnderConstruction",
      "Health Insurance": "UnderConstruction",
      "Disability Insurance": "UnderConstruction",
      "Long-Term Care Insurance": "UnderConstruction",
      "Life Insurance Needs": "UnderConstruction",
      "Health Insurance Costs": "UnderConstruction",
      "Disability Insurance Needs": "UnderConstruction",
      "Long-Term Care Insurance Costs": "UnderConstruction",
  },

  Estate: {
    "Wills and Trusts": "UnderConstruction",
    "Power of Attorney": "UnderConstruction",
    "Healthcare Proxy": "UnderConstruction",
    "Estate Taxes": "UnderConstruction",
    "Estate Value": "UnderConstruction",
    "Estate Tax Liability": "UnderConstruction",
    "Trust Funding": "UnderConstruction",
    "Beneficiary Designations": "UnderConstruction",
  },

  Health: {
    Cardio: "UnderConstruction",
    Strength: "UnderConstruction",
    Vitamins: "UnderConstruction",
    Hydration: "UnderConstruction",
  },
  
  
  Activity: {
    "Golf: Fitness": "GolfFitness",
    "Golf: Courses": "UnderConstruction",
    "Golf: Coach": "UnderConstruction",     

    "Pickleball: Fitness": "GolfFitness",
    "Pickleball: Courses": "UnderConstruction",
    "Pickleball: Coach": "UnderConstruction",   

    "Ski: Fitness": "GolfFitness",
    "Ski: Courses": "UnderConstruction",
    "Ski: Coach": "UnderConstruction", 
    
    "Travel": "UnderConstruction",

    "Chess: Fitness": "GolfFitness",
    "Chess: Courses": "UnderConstruction",
    "Chess: Coach": "UnderConstruction",     
  },
};

export default menuData;